const radDownPageRouter = [
  {
    path: '/radDownPage/invitation',
    name: 'invitation',
    component: () => import('@/views/wxapp/radDownPage/share/invitation'),
    meta: {
      title: '风格测试'
    }
  },
  {
    path: '/radDownPage/changeProblem',
    name: 'changeProblem',
    component: () => import('@/views/wxapp/radDownPage/change/changeProblem'),
    meta: {
      title: '风格测试'
    }
  },
  {
    path: '/radDownPage/result',
    name: 'result',
    component: () => import('@/views/wxapp/radDownPage/testComplete/result'),
    meta: {
      title: '风格测试'
    }
  },
  {
    path: '/radDownPage/designer',
    name: 'designer',
    component: () => import('@/views/wxapp/radDownPage/testComplete/designer'),
    meta: {
      title: '风格测试'
    }
  }
]
export default radDownPageRouter
